import { render, staticRenderFns } from "./StoreShippingServiceForm.vue?vue&type=template&id=297fd650&scoped=true"
import script from "./StoreShippingServiceForm.vue?vue&type=script&lang=js"
export * from "./StoreShippingServiceForm.vue?vue&type=script&lang=js"
import style0 from "./StoreShippingServiceForm.vue?vue&type=style&index=0&id=297fd650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fd650",
  null
  
)

export default component.exports